<template>
  <div class="container flex" style="margin-bottom: 20px;margin-top: 15px;">
    <left></left>
    <div class="live flex1" style="margin-left: 20px;background-color: #fff;">
  <!--  	<div class="title" style="line-height: 60px;">
    		错题收藏
    	</div> -->
      <div class="lists test" v-for="item,index in testList" style="text-indent: 16px;background-color: #fff;border-bottom: 1px solid #ccc;margin-bottom: 0;">
      		<div class="title flex " style="background-color: #fff;font-size: 16px;"><span class="flex1">{{item.title}}</span>
          <div class="viewWrap">

          	<span class="view" @click="handleError(item.testQuestionsId,1,2,item.collCount)">{{item.collCount}} 收藏</span>
          </div>
          <div class="viewWrap">

          	<span class="view" @click="handleError(item.testQuestionsId,1,1,item.errorCount)">{{item.errorCount}} 错题</span>
          </div></div>


      	</div>
   	<div class="lists" v-for="item,index in list">
    		<div class="listtile" @click="handleShow(index)">
    			{{item.title}}
    		</div>
    		<template v-if="item.show">
    		  <div class="list" v-for="voo in item.testQuestionsChildList">
    		  	<span class="childName">{{voo.title}}</span>

    		  	<div class="viewWrap">
    		  		<span class="view" @click="handleError(voo.testQuestionsId,2,2,voo.collCount)">{{voo.collCount}} 收藏</span>
    		  	</div>
    		  	<div class="viewWrap">
    		  		<span class="view" @click="handleError(voo.testQuestionsId,2,1,voo.errorCount)">{{voo.errorCount}} 错题</span>
    		  	</div>
    		  </div>
    		</template>

    	</div>
   <!--   <div class="" style="padding: 15px;">错题集</div>
    	<div class="lists" v-for="item in list">
    		<div class="listtile flex" style="align-items: center;" @click="handleList(item.error_question_status,item.errorQuestionStatusName,1)">
    			{{item.errorQuestionStatusName}}<span class="flex1"></span>{{item.errorQuestionCount}}
          <img src="../assets/img/toright.png" width="8" height="14" style="margin: 0 15px;" />
    		</div>
    	</div>
      <div  style="padding: 15px;">收藏集</div>
      <div class="lists" v-for="item in collectList">
      	<div class="listtile flex" style="align-items: center;" @click="handleList(item.error_question_status,item.errorQuestionStatusName,2)">
      		{{item.errorQuestionStatusName}}<span class="flex1"></span>{{item.errorQuestionCount}}
          <img src="../assets/img/toright.png" width="8" height="14" style="margin: 0 15px;" />
      	</div>
      </div> -->

    </div>
  </div>
</template>

<script>
  import left from './left.vue'
  export default {
    name: 'Footer',
    components:{
      left
    },
    data () {
      return {
          data:'',
          list:[],
          testList:[]
      }
    },
    methods:{
      handleShow(index){
        console.log(index)
        this.$forceUpdate()
        this.list[index].show=!this.list[index].show;
      },
      getData(){
        this.$axios.get(this.$common.testPaper_appExercisesList+'?pageSize=1000000').then((res)=>{
              if(res.data.code==1){
                  let list=res.data.data.list;
                      console.log(list)
                      list.forEach((item)=>{
                          item.testQuestionsChildList=item.testQuestionsChildList.filter((voo)=>{
                            return voo.collCount || voo.errorCount
                          })
                      })
                      list=list.filter((item)=>{
                        return  item.testQuestionsChildList.length>0
                      })
                  this.list=list
              }
              else {
                alert(res.data.msg)
              }
        })
      },
      handleError(chapterId,type,tag,count){

        if(count==0){

          return;
        }

        this.$router.push('dotest?chapterId='+chapterId+'&type='+type+'&tag='+tag)
      },
      handleList(type,errorQuestionStatusName,tag){
          this.$router.push('dotest?errorQuestionStatus='+type+'&errorQuestionStatusName='+errorQuestionStatusName+'&tag='+tag)
      },
      getDataList(){
        this.$axios.get(this.$common.testPaper_appTestExercisesList+'?pageSize=1000000').then((res)=>{
              if(res.data.code==1){
                  this.testList=res.data.data.list.filter((item)=>{
                    return item.collCount || item.errorCount
                  });
              }
              else {
                alert(res.data.msg)
              }
        })
      }
    },
    created(){
      this.getData();
      this.getDataList();
   //   this.getCollectData();
    }
  }
</script>

<style scoped="">
  .test .title .view {
      color: #4fa7ff;
      border: 1px solid #4fa7ff;
      text-align: center;
      display: inline-block;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      text-indent: 0;
      width: 100px;
      height: 40px !important;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      margin-right: 15px;
      cursor: pointer;
      font-weight: normal;
  }
  .test .title {
    align-items: center;
  }
  .live .list .view {
    padding: 0;
    width: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/errorcollect.vue